import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import RouterWrapper from './Routes';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <RouterWrapper />
    </BrowserRouter>
  );
}

export default App;